module.exports = __webpack_public_path__ + "img/19@2x.c5b84d53.png";